import styled from 'styled-components';
import { ButtonTag } from '../../components/Button/styles';

export const BriefHotelInfo = styled.article`
  position: fixed;
  z-index: 6;
  left: 0;
  bottom: 0;

  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 20px 25px;

  background-color: ${({ theme }) => theme.white};
  box-shadow: 0px -8px 24px rgba(0, 0, 0, 0.08);
  border-radius: 6px 6px 0 0;
`;

export const BriefColumn = styled.div`
  display: flex;
  flex-direction: column;
  filter: blur(${ props  => props.blured ? '5px' : '0'});
`;

export const BriefStarsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const BriefStars = styled.p`
  margin: 0;
  margin-right: 5px;
  padding: 0;

  font-size: 14px;
  line-height: 1;
  color: ${({ theme }) => theme.blue};
`;

export const Price = styled.p`
  margin: 0;
  margin-bottom: 5px;
  padding: ${({ yellowBack }) => yellowBack ? '5px 3px' : 0};

  font-weight: 700;
  font-size: 16px;
  line-height: 1;

  border-radius: 10px;

  background-color: ${({ theme, yellowBack }) => yellowBack ? theme.yellow : theme.white};

  color: #4e4e4e;

  span {
    font-size: 12px;
  }
`;

export const OldPrice = styled.p`
  margin: 0;
  margin-bottom: 5px;
  padding: 0;

  font-weight: 700;
  font-size: 12px;
  line-height: 1;
  color: ${({ theme }) => theme.black};
  text-decoration: line-through;
  color: #4e4e4e;

  span {
    font-size: 12px;
  }
`;

export const BriefButton = styled(ButtonTag)`
  padding: 8px 35px;
`;

export const ModalContainer = styled.div`
  position: fixed;
  z-index: 5;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  background-color: ${({ theme }) => theme.white};

  overflow: scroll;
`;

export const ModalButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;

  display: flex;
  width: 57px;
  height: 57px;

  border-bottom-left-radius: 100px;
  background: linear-gradient(135deg, #2DB9FE 0%, #4EDBFC 100%);
  box-shadow: 0 8px 20px rgba(30, 182, 255, 0.24);

  svg {
    margin-left: 25px;
    margin-top: -10px;
    stroke: ${({ theme }) => theme.white};
  }
`;
